<template>
  <path
    d="M12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 12 2.00024ZM6.5 9.00024L9.65 5.85024C9.85 5.65024 10.16 5.65024 10.36 5.85024L13.5 9.00024H11V13.0002H9V9.00024H6.5ZM14.35 18.1502C14.15 18.3502 13.84 18.3502 13.64 18.1502L10.5 15.0002H13V11.0002H15V15.0002H17.5L14.35 18.1502Z"
  />
</template>
